import { useQuery } from "react-query";
import Candidate from "../apiResources/Candidate";
import { JobType } from "../apiResources/Job";
import { PaginationQuery } from "./types";

interface CandidatesQuery extends PaginationQuery {
  query?: string;
  jobType?: JobType | JobType[];
  excludedEngagement?: number | string;
}

const fetchCandidates = async (queryData: CandidatesQuery) => {
  const { page, per, query, jobType, excludedEngagement } = queryData;
  const response = await Candidate.where({
    full_name: { match: query },
    exclude_engagement_id: excludedEngagement,
    jobType,
  })
    .page(page)
    .per(per)
    .order({ updated_at: "desc" })
    .stats({ total: "count" })
    .all();

  let hasMore = false;

  if (page && per) {
    hasMore = response.meta.stats.total.count > page * per;
  }

  return {
    candidates: response.data,
    meta: {
      hasMore,
      total: response.meta.stats.total.count,
    },
  };
};

export const useCandidates = (params: CandidatesQuery) => {
  return useQuery(["candidates", params], () => fetchCandidates(params), {
    keepPreviousData: true,
  });
};
